(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/quickplay/services/analytics.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/quickplay/services/analytics.js');
'use strict';

class Analytics extends svs.tur.payment.services.Analytics {
  constructor(_ref) {
    let {
      wagerId = 0,
      betsObj,
      wagerModel,
      isSyndicate
    } = _ref;
    super({
      wagerId,
      betsObj,
      wagerModel,
      isSyndicate
    });
  }
  createExtraData() {
    var _this$betsObj$, _this$betsObj$$kenoBo;
    const extraData = {
      quickPick: 1,
      rounds: 1,
      bag: "".concat(this.wagerModel.get('price'), ":").concat(this.productName.toLowerCase(), " ").concat(this.wagerModel.get('price'))
    };
    if ((_this$betsObj$ = this.betsObj[0]) !== null && _this$betsObj$ !== void 0 && (_this$betsObj$$kenoBo = _this$betsObj$.kenoBoards) !== null && _this$betsObj$$kenoBo !== void 0 && _this$betsObj$$kenoBo.some(b => /KK/.test(b.participation))) {
      extraData.kungkeno = true;
    }
    return extraData;
  }
}
svs.tur.payment.api.jupiter.quickplay.services.Analytics = Analytics;

 })(window);